import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { IonButton, IonIcon, IonItem } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, pencilOutline } from 'ionicons/icons';
import { Observable } from 'rxjs';
import { SlipComponentInfo } from '../../student-slip-item-choices-modal/student-slip-item-choices-modal.store';
import { ItemChoicesComponentInfo, PaymentStatus } from '../../student-slip-modal.store';
import { FormState, StudentSlipItemChoicesPaymentWebStore } from './student-slip-item-choices-payment-web.store';
declare const Stripe: any;
let uniqueId = 0;

@Component({
  selector: 'app-student-slip-item-choices-payment-web',
  templateUrl: './student-slip-item-choices-payment-web.component.html',
  styleUrls: ['./student-slip-item-choices-payment-web.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StudentSlipItemChoicesPaymentWebStore],
  imports: [CommonModule, IonItem, IonButton, IonIcon, ReactiveFormsModule]
})
export class StudentSlipItemChoicesPaymentWebComponent implements OnInit, OnDestroy {
  @Input() set slipComponentInfo(value: SlipComponentInfo) {
    this.store.patchState({ slipComponentInfo: value });
  }
  @Input() itemChoicesComponentInfo: ItemChoicesComponentInfo;
  @Input() paymentStatus: PaymentStatus;
  @Input() reservationExpiresOn: string;

  @Output() readonly paymentStatusChange = this.store.paymentStatus$;
  @Output() requestReservationRefresh = new EventEmitter<void>();

  @ViewChild('cardInfo', { static: false }) set cardInfo(value: ElementRef) {
    if (value) {
      this.store.initialiseStripe({
        stripe: this.stripe,
        cardInfo: value,
        paymentRequestButtonId: this.paymentRequestButtonId
      });
    }
  }
  stripe: any;
  paymentForm = this.fb.group({});
  paymentRequestButtonId = `payment-request-button-${uniqueId++}`;

  readonly vm$: Observable<FormState> = this.store.vm$;

  constructor(
    private store: StudentSlipItemChoicesPaymentWebStore,
    private fb: UntypedFormBuilder
  ) {
    addIcons({ pencilOutline, informationCircleOutline });
  }

  ngOnInit(): void {
    this.store.patchState({
      paymentStatus: this.paymentStatus,
      itemChoicesComponentInfo: this.itemChoicesComponentInfo,
      payNowAmount: this.itemChoicesComponentInfo.balance,
      canEditAmount:
        this.itemChoicesComponentInfo.minimumAmount > 0 &&
        this.itemChoicesComponentInfo.balance >= this.itemChoicesComponentInfo.minimumAmount + 100,
      reservationExpiresOn: this.reservationExpiresOn,
      refreshReservationEmitter: this.requestReservationRefresh
    });

    this.stripe = Stripe(this.itemChoicesComponentInfo.paymentKey);
  }

  ngOnDestroy(): void {
    this.store.destroyCard();
  }

  onEditAmount(): void {
    this.store.editAmount();
  }

  async onSubmit(): Promise<void> {
    if (this.paymentForm.valid) {
      this.store.payNow({ stripe: this.stripe });
    }
  }
}
